import { IGSSAResults } from '@/interfaces/IGSSAResults';
import { IReview } from '@/interfaces/IReview';
import { IState } from '@/interfaces/Store';
import { reactive } from 'vue';

const state: IState = reactive<IState>({
	error: null,
	loggedIn: false,
	university: null,
	universities: [],
	thumbedReviews: [],
	flaggedReviews: [],
	loadPopup: false,
	showPopup: false,
	gssaResults: new Map<number, IGSSAResults | null>(),
	reviewsPerUniversity: new Map<number, IReview[]>(),
	showPopupPerUniversity: new Map<number, boolean>(),
});

export default state;
